import { forwardRef, useImperativeHandle, useState } from "react";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import Dropdown from "../Dropdown/Dropdown";
import "./GroupBy.css";

export interface GroupByPopupRef {
  closePopup: () => void;
}

interface Option {
  label: string;
  value: string;
}
interface GroupByProps {
  options: Option[];
  selectedGroups: string[];
  onGroupsChange: (groups: string[]) => void;
  onGroupsClear: () => void;
}

const GroupBy = forwardRef<GroupByPopupRef, GroupByProps>(
  ({ options, selectedGroups, onGroupsChange, onGroupsClear }, ref) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [localSelected, setLocalSelected] = useState<Option[]>(
      options.filter((opt) => selectedGroups.includes(opt.value))
    );

    useImperativeHandle(ref, () => ({
      closePopup: () => setIsPopupOpen(false),
    }));

    const handleSelect = (selected: Option | Option[]) => {
      let arr: any[] = [];
      if (Array.isArray(selected)) {
        arr = selected;
      } else if (selected) {
        arr = [selected];
      }
      setLocalSelected(arr);
    };

    const handleApply = () => {
      onGroupsChange(localSelected.map((s) => s.value));
      setDropdownOpen(false);
      setIsPopupOpen(false);
    };

    return (
      <div className="groupByContainer">
        <img
          className="groupByIcon"
          onClick={(e) => {
            setIsPopupOpen(!isPopupOpen);
            e.stopPropagation();
          }}
          src="Filter.png"
          alt="filter"
        />
        {isPopupOpen && (
          <div
            onClick={(e: any) => {
              e.stopPropagation();
              setDropdownOpen(false);
            }}
            className="groupBy"
          >
            <div className="groupByHeader">
              <div className="groupTitle">
                <img src="Group List.png" alt="group" />
                <span>Group by</span>
              </div>
              <img
                style={{ height: "16px", width: "16px", cursor: "pointer" }}
                src="Dismiss.png"
                alt="dismiss"
                onClick={() => setIsPopupOpen(false)}
              />
            </div>
            <Dropdown
              multiselect
              onSelect={handleSelect}
              filterOptions={options}
              open={dropdownOpen}
              setOpen={setDropdownOpen}
              selectedOptions={localSelected}
            />
            <div className="groupByButtons">
              <ButtonComponent
                name="Apply"
                selected="Apply"
                onClick={handleApply}
              />
              <ButtonComponent
                name="Clear"
                selected=""
                onClick={onGroupsClear}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default GroupBy;
